import { useEffect, useRef } from 'react';
import { LunchCardAPI, generateQRDataWithId } from '@/lib/lunchCardService';
import { formatSwedishPhone } from '@/lib/phoneUtils';
import { CreditCard } from 'lucide-react';
import QRCode from 'qrcode';

interface QRCodeDisplayProps {
  card: LunchCardAPI;
  showInstructions?: boolean;
}

export const QRCodeDisplay = ({ card, showInstructions = false }: QRCodeDisplayProps) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    // Generate QR with card ID
    const qrData = generateQRDataWithId(card.id, 'private');
    
    QRCode.toCanvas(canvas, qrData, {
      width: 200,
      margin: 2,
      color: {
        dark: '#1a1a1a',
        light: '#FFFFFF',
      },
    });
  }, [card]);

  return (
    <div className="flex flex-col items-center">
      <div className="bg-card rounded-2xl shadow-warm-lg p-6 border border-border">
        <div className="bg-background p-4 rounded-xl mb-4">
          <canvas ref={canvasRef} className="mx-auto" />
        </div>

        <div className="text-center">
          <p className="text-sm text-muted-foreground mb-1">Telefonnummer</p>
          <p className="font-medium text-foreground">{formatSwedishPhone(card.phoneNumber)}</p>
        </div>
      </div>

      <div className="mt-6 flex items-center gap-3 px-6 py-4 rounded-xl bg-primary/10">
        <CreditCard size={24} className="text-primary" />
        <div>
          <p className="text-sm text-muted-foreground">Luncher kvar</p>
          <p className="text-2xl font-bold text-primary">{card.remaining}</p>
        </div>
      </div>

      {showInstructions && (
        <div className="mt-6 p-4 rounded-lg bg-secondary/50 text-center max-w-xs">
          <p className="text-sm text-muted-foreground">
            Visa denna QR-kod i kassan för att använda dina luncher
          </p>
        </div>
      )}
    </div>
  );
};
